import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild  } from '@angular/core';
import { SharedService } from 'src/app/shared/services/shared.service';
import { environment } from 'src/environments/environment';
declare var $: any;
import videojs, { VideoJsPlayer } from 'video.js';

@Component({
  selector: 'app-the-great-ind-musical',
  templateUrl: './the-great-ind-musical.component.html',
  styleUrls: ['./the-great-ind-musical.component.css']
})
export class TheGreatIndMusicalComponent implements OnInit, AfterViewInit {
  contactKeyArray = [];
  subscription;
  eventData:any;
  eventOverleyData:any;
  baseUrl = environment.staticUrlForImgNew
  @ViewChild('videoPlayer', { static: false }) videoElement!: ElementRef;
  player!: VideoJsPlayer;
  videoPlayers: VideoJsPlayer[] = [];
  isVisible = false;
  videoSrc: string = '';
  modalMediaItems = [];
  cta:any;
  
  isModalMuted = false;
  constructor(private renderer: Renderer2,
    public _sharedService: SharedService
  ) { 
    this.getContactKeys();

  }

   ngOnInit() {
    this.getContactUsPageContent();
    
  }
  getContactKeys() {
    return this.contactKeyArray = [
    "NMACC-NYC-CTN",
    "NMACC-NYC-CTN-OVERLAY"
    ];
  }
  async ngAfterViewInit() {
    try {
      await this.loadScript('assets/nycJs/jquery-3.3.1.min.js');

      if (!(window as any).jQuery) {
        throw new Error('jQuery not available globally');
      }

      await this.loadScript('assets/nycJs/popper.min.js');
      await this.loadScript('assets/nycJs/bootstrap.min.js');
      await this.loadScript('assets/nycJs/slick.min.js');
      await this.loadScript('assets/nycJs/main.js');

      console.log('All scripts loaded');
    } catch (error) {
      console.error('Script loading failed:', error);
    }

    $('#nma-about-modal11').on('hidden.bs.modal', () => {
      if (this.player) {
        this.player.pause();
      }
    });
    this.videoElement.nativeElement.addEventListener('ended', () => {
      $('#nma-about-modal11').modal('hide');
    });
    this.initVideoPlayers();
    
  }
  
  initVideoPlayers() {
    // Dispose previous players if any
    this.disposeVideoPlayers();

    this.modalMediaItems.forEach((media, i) => {
      if (media.type === 'video') {
        const player = videojs(`video-player-${i}`, {
          autoplay: false,
          controls: true,
          preload: 'auto',
          fluid: true,
          sources: [
            {
              src: media.url,
              type: 'application/x-mpegURL' // important for HLS
            }
          ],
        });
        this.videoPlayers.push(player);
      }
    });
  }

  disposeVideoPlayers() {
    this.videoPlayers.forEach(player => player.dispose());
    this.videoPlayers = [];
  }

  ngOnDestroy() {
    this.disposeVideoPlayers();
  }
  loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = this.renderer.createElement('script');
      script.src = src;
      script.type = 'text/javascript';
      script.onload = () => {
        console.log(`${src} loaded`);
        resolve();
      };
      script.onerror = (err) => reject(err);
      this.renderer.appendChild(document.body, script);
    });
  }
  getContactUsPageContent() {
    this.subscription = this._sharedService.getCommonService().getlandingUrl(this.contactKeyArray).subscribe(
      (data: any) => {  
        this.eventData = data[0]?.data
        this.modalMediaItems = [];

        const items = this.eventData.cards[0]?.CardImageVideoDetails || [];
        
        this.modalMediaItems = items.map(card => {
          const mediaItems = [];
        
          const videoUrl = card?.VideoLink?.data?.trim();
          if (videoUrl) {
            mediaItems.push({
              type: 'video',
              url: videoUrl
            });
          }
        
          const imageUrl = card?.CardImage?.document?.contentUrl?.trim();
          if (imageUrl) {
            mediaItems.push({
              type: 'image',
              url: imageUrl,
              alt: card?.CardImageAltText?.data || ''
            });
          }
        
          return mediaItems;
        }).flat(); // Flatten if multiple media per card
        this.cta = this.eventData.cards[0]?.CTADetails?.find(detail => detail.CTAText?.data);
        
        this.eventOverleyData = data[1]?.data
      },
      (error) => {
        console.log("Try after some time..");;
      }
    )
  }

  formatLink(url: string): string {
    if (!url) return '#';
    // Add http if missing (simple check)
    if (!/^https?:\/\//i.test(url)) {
      return 'https://' + url;
    }
    return url;
  }

  openVideoModal(src: string) {
    this.videoSrc = src;
    this.isModalMuted = false; 
    const isMp4 = /\.mp4(\?.*)?$/i.test(src);
    const mimeType = isMp4 ? 'video/mp4' : 'application/x-mpegURL';
      
    $('#nma-about-modal11').modal('show');
      
    setTimeout(() => {
      if (!this.player) {
        this.player = videojs(this.videoElement.nativeElement, {
          autoplay: true,
          controls: true,
          muted: false,    
          bigPlayButton: false,         
          sources: [
            {
              src: this.videoSrc,
              type: mimeType,
            },
          ],
        });
      } else {
        this.player.src({ src: this.videoSrc, type: mimeType });
        this.player.muted(false);    // Unmute if player already exists
        this.player.play();
      }
    }, 300);
  }
  
  toggleMuteModal() {
    this.isModalMuted = !this.isModalMuted;
    if (this.player) {
      this.player.muted(this.isModalMuted);
    }
  }
  close() {
    this.isVisible = false;
    if (this.player) {
      this.player.pause();
      $('#nma-about-modal11').modal('hide');
    }
  }
  
}
